import React from "react";
import "./BoardMembers.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import BMImages from "../../../Component/ReuseComponent/BMImages/BMIamges";
import BMS1Img1 from "../../../Assets/images/BoardMembers/BMS1Img1.webp";
import BMS1Img2 from "../../../Assets/images/BoardMembers/BMS1Img2.webp";
import BMS1Img3 from "../../../Assets/images/BoardMembers/BMS1Img3.webp";
import BMS1Img4 from "../../../Assets/images/BoardMembers/BMS1Img4.webp";
import BMS1Img5 from "../../../Assets/images/BoardMembers/BMS1Img5.webp";
import BMS1Img6 from "../../../Assets/images/BoardMembers/BMS1Img6.webp";
import BMS4Img from "../../../Assets/images/BoardMembers/BoardMembersS4Img.webp";
import BMS4ImgMob from "../../../Assets/images/BoardMembers/BoardMembersS4ImgMob.webp";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ImgBox from "../../../Component/ReuseComponent/ImgBox/ImgBox";
export default function BoardMembersContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();

  return (
    <>
      <div className="BoardMembersContainer">
        <VisibilitySection index={0} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS1">
          <BoardMembersS1 />
        </VisibilitySection>
        <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS2">
          <BoardMembersS2 />
        </VisibilitySection>
        <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS3">
          <BoardMembersS3 />
        </VisibilitySection>
        <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS4">
          <BoardMembersS4 />
        </VisibilitySection>
      </div>
    </>
  );
}
function BoardMembersS1() {
  return (
    <>
      <div className="BoardMembersS1">
        <div className="BoardMembersS1P1">
          <TC3L
            // Head="board members"
            Title="Meet the Minds Behind Milky’s"
            TitleWidthMob="60vw"
          />
        </div>
        <div className="BoardMembersS1P2">
          <BMImages ImgSrc={BMS1Img1} ImgAlt="" Head="John Carter" Title="Chairman of the Board" />
          <BMImages ImgSrc={BMS1Img2} ImgAlt="" Head="Emily Rodriguez" Title="Chief Operations Officer" />
          <BMImages ImgSrc={BMS1Img3} ImgAlt="" Head="Mark Ibrahim" Title="Head of Sustainability" />
        </div>
      </div>
    </>
  );
}
function BoardMembersS2() {
  return (
    <>
      <div className="BoardMembersS2">
        <BMImages ImgSrc={BMS1Img4} ImgAlt="" Head="Sophia Lane" Title="Director of Animal Welfare" />
        <BMImages ImgSrc={BMS1Img5} ImgAlt="" Head="Michael O’Donnell" Title="Chief Financial Officer" />
        <BMImages ImgSrc={BMS1Img6} ImgAlt="" Head="Laila Ahmed" Title="Marketing Lead" />
      </div>
    </>
  );
}
function BoardMembersS3() {
  return (
    <>
      <div className="BoardMembersS3">
        <div className="BMS3P1">
          <TC3L
            // Head="About Our Farmers"
            Title={<>Celebrating the Heart and Soul of Milky's Farm</>}
            TitleWidth="56vw"
            TitleWidthMob="80vw"
            Para="Behind every glass of milk is the dedication of our farmers. They work tirelessly to ensure the highest quality for your family while embracing
            sustainable and ethical practices. Milky's Farm is proud to have a team of passionate individuals who care deeply about the land, the animals, and
            the community"
            ParaWidth="56vw"
            ParaWidthMob="90vw"
          />
        </div>
      </div>
    </>
  );
}
function BoardMembersS4() {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="BoardMembersS4">
        <ImgBox ImgSrc={isMobile ? BMS4ImgMob : BMS4Img} ImgAlt="" />
      </div>
    </>
  );
}
